// Sekcja „Laureaci" — rozwijanie listy nagród codziennych.
//
// Lista ma 63 dni, więc w makiecie (Figma 142:687) jest zwinięta, a nad nią stoi
// przycisk „Rozwiń listę". Jedynym źródłem prawdy o stanie jest `aria-expanded`
// na przycisku: atrybut `hidden` na liście, kolory przycisku, obrót daszka
// i przełączenie etykiety na „Zwiń listę" są jego pochodnymi w CSS
// (patrz s-winners.scss) — dlatego JS nie rusza tu ani treści, ani klas.
document.querySelectorAll('.s-winners__toggle').forEach((toggle) => {
	const list = document.getElementById(toggle.getAttribute('aria-controls'));

	if (!list) {
		return;
	}

	toggle.addEventListener('click', () => {
		const expanded = toggle.getAttribute('aria-expanded') !== 'true';

		toggle.setAttribute('aria-expanded', String(expanded));
		list.hidden = !expanded;
	});
});
